/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import {
  CreateEmailTemplateProps,
  DeleteEmailTemplateProps,
  UpdateEmailTemplateProps,
} from "./components";

export class DeleteBoxEmailTemplatePageService {
  private static instance: DeleteBoxEmailTemplatePageService;
  private vapp: VApplication;
  private headers: any;
  private nodesCollapsed = {};

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): DeleteBoxEmailTemplatePageService {
    if (!DeleteBoxEmailTemplatePageService.instance) {
      DeleteBoxEmailTemplatePageService.instance =
        new DeleteBoxEmailTemplatePageService(props);
    }
    return DeleteBoxEmailTemplatePageService.instance;
  }

  public getCollapsedNodes = () => {
    return this.nodesCollapsed;
  };

  public setCollapsedNodes = (nodes: any) => {
    this.nodesCollapsed = nodes;
  };

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = {
        ...content,
        ...compProps,
      };
    }
    console.log(`------>compProps ===`, compProps);
    return content;
  }

  public async getPageContent(args: any) {
    const agent = getAgent();
    const content = await agent.getStaticPageContentSync({});

    console.log("Called EmailTemplatePageService", content);
    return content;
  }

  public async getEmailTemplates(args: any) {
    const agent = getAgent();
    return agent.getEmailTemplates(args);
  }

  public async createEmailTemplate(args: CreateEmailTemplateProps) {
    const agent = getAgent();
    return agent.createEmailTemplate(args);
  }

  public async updateEmailTemplate(args: UpdateEmailTemplateProps) {
    const agent = getAgent();
    return agent.updateEmailTemplate(args);
  }

  public async deleteEmailTemplate(args: DeleteEmailTemplateProps) {
    const agent = getAgent();
    return agent.deleteEmailTemplate(args);
  }
}
